import { buildColumnFilter } from '@witmetrics/utils/filters';
import {
  COMPARISON_OPERATORS,
  FORM_STATUS_ID,
} from '@witmetrics/utils/constants';
import { API } from '@/api';
import type { Answers } from './types';

export function buildInitialAnswers(): Answers {
  return {};
}

export async function fetchPracticeForms(practiceId: number) {
  // Only fetch forms that are currently active
  return (
    await API.Practices.fetchPracticeForms(practiceId, {
      pagination: { page: 1, pageSize: 100 },
      filters: [
        buildColumnFilter(
          'formStatusId',
          COMPARISON_OPERATORS.EQUALS.value,
          FORM_STATUS_ID.ACTIVE
        ),
      ],
    })
  ).results;
}

export async function fetchForm(formId: number) {
  const [form, version] = await Promise.all([
    API.Forms.fetchForm(formId),
    API.Forms.fetchLatestFormVersion(formId),
  ]);
  return {
    form,
    version,
    answers: version.fields.reduce(
      (a, { id }) => ({ ...a, [id]: '' }),
      {} as Answers
    ),
  };
}

export async function fetchSubmission(submissionId: number) {
  const { form, formVersion, formSubmission } =
    await API.Forms.fetchFormSubmission(submissionId);
  return {
    form,
    formVersion,
    formSubmission,
    answers: formSubmission.answers.reduce(
      (a, { formFieldId, value }) => ({ ...a, [formFieldId]: value }),
      {} as Answers
    ),
  };
}
